<template>
  <section>
    <ol class="questions">
      <fieldset>
        <legend>
          <span class="h3">Contact Information</span>
        </legend>
        <ol class="questions compact">
          <li>
            <InputWithError 
              label="What is person 1's email address?"
              size="30"
              id="partyOneEmail"
              v-model="contactInfo.partyOneEmail"
              name="Party 1 Email"
              required="true"
            />
          </li>
          <li>
            <InputWithError 
              label="What is person 1's mobile number?"
              size="30"
              id="partyOneMobile"
              v-model="contactInfo.partyOneMobile"
              name="Party 1 Mobile"
              required="true"
            />
          </li>
        </ol>
        <ol class="questions compact">
          <li>
            <InputWithError 
              label="What is person 2's email address?"
              size="30"
              id="partyTwoEmail"
              v-model="contactInfo.partyTwoEmail"
              name="Party 2 Email"
              required="true"
            />
          </li>
          <li>
            <InputWithError 
              label="What is person 2's mobile number?"
              id="partyTwoMobile"
              size="30"
              v-model="contactInfo.partyTwoMobile"
              name="Party 2 Mobile"
              required="true"
            />
          </li>
        </ol>
      </fieldset>
    </ol>
  </section>
</template>

<script>
import InputWithError from '../InputWithError.vue'

export default {
  data() {
    return {
    }
  },
  props: {
    number: String,
    value: Object,
  },
  computed: {
    contactInfo: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    }
  },
  components: {
    InputWithError
  }
}
</script>